import {
	WebAPIBarGraphChartSlicerData,
	WebAPIChartCategory,
	WebAPIChartTopic,
} from '../../../../globals/webApiTypes/elements/WebAPICBS';

export const getTopicLabelAlias =
	(labelAliases: WebAPIBarGraphChartSlicerData['labelAliases'] = {}) =>
	(topic: WebAPIChartTopic) =>
		labelAliases[`topic/${topic.key}`];

export const getCategoryLabelAlias =
	(labelAliases: WebAPIBarGraphChartSlicerData['labelAliases'] = {}) =>
	(category: WebAPIChartCategory) =>
		labelAliases[`category/${category.dimensionKey}/${category.key}`];

export const getDimensionLabelAlias =
	(labelAliases: WebAPIBarGraphChartSlicerData['labelAliases'] = {}) =>
	(dimensionKey: string) =>
		labelAliases[`dimension/${dimensionKey}`];

export const getLabelAlias =
	(labelAliases: WebAPIBarGraphChartSlicerData['labelAliases']) =>
	(entity: WebAPIChartTopic | WebAPIChartCategory) => {
		return 'dimensionKey' in entity
			? getCategoryLabelAlias(labelAliases)(entity)
			: getTopicLabelAlias(labelAliases)(entity);
	};
